import { ComponentsOverrides, ComponentsVariants } from "@mui/material";

declare module "@mui/material/Button" {
    interface ButtonPropsVariantOverrides {
      accept: true;
      cancel: true;
    }
  }

const variants: ComponentsVariants["MuiButton"] = [
  {
    props: { variant: "accept" },
    style: {
      background: "linear-gradient(to bottom, #94bc1d, #679714)",
      borderColor: "#5d8c12",
      "&:hover": {
        background: "linear-gradient(to top, #659614, #659614)",
        borderColor: "#659614",
      },
      "&:active": {
        background: "linear-gradient(to top, #659614, #659614)",
        borderColor: "#659614",
      },
    },
  },
  {
    props: { variant: "cancel" },
    style: {
      backgroundColor: "#6c757d",
      borderColor: "#6c757d",
      "&:hover": {
        backgroundColor: "#5a6268",
        borderColor: "#5a6268",
      },
      "&:active": {
        backgroundColor: "#5a6268",
        borderColor: "#5a6268",
      },
    },
  },
];

const styleOverrides: ComponentsOverrides["MuiButton"] = {
  root: {
    lineHeight: 1.5,
    border: "1px solid",
    fontSize: 16,
    padding: "6px 12px",
    textTransform: "none",
    boxShadow: "none",
    margin: "0px 5px",
    fontFamily:
      "-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol",

    color: "white",
    "&:hover": {
      color: "white",
      boxShadow: "none",
    },
    "&:active": {
      color: "white",
      boxShadow: "none",
    },
  },
};

const StyledButtons = {
  variants,
  styleOverrides,
};

export default StyledButtons;
